import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import GiftingHero from '@/components/gifting/GiftingHero';
import GiftingFeature from '@/components/gifting/GiftingFeature';

const GiftingLanding = () => {
  return (
    <div className="min-h-screen w-full bg-background">
      <Navbar />
      
      <main className="w-full">
        <GiftingHero />
        <GiftingFeature />
      </main>
      
      <Footer />
    </div>
  );
};

export default GiftingLanding;